import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Genvej til lead-pipeline-emails.
 * Viser send-status (queued/success/fail) + fejlårsag for hver e-mail
 * der er sendt fra lead-pipelinen, ved at pre-filtrere email-loggen
 * på `admin-quick-message`-templatet.
 *
 * Selve UI'et (status-badges, fejl-detaljer, gen-send) findes allerede
 * i `/admin/emails` og bruges som-er — så vi har én kilde til sandhed.
 */
export const Route = createFileRoute("/admin/lead-emails")({
  beforeLoad: () => {
    throw redirect({
      to: "/admin/emails",
      search: {
        hours: 168,
        template: "admin-quick-message",
        status: "all",
        q: "",
        page: 0,
      },
    });
  },
});
